import React from 'react';
import { Link } from 'react-router-dom';
import { useBreadcrumbFromSidebar } from '../../hooks/ui/useBreadcrumbFromSidebar';
import SvgIcon from '../SvgIcon/SvgIcon';

const BreadcrumbTwo: React.FC = () => {
  const breadcrumbItems = useBreadcrumbFromSidebar();

  const pageTitle =
    breadcrumbItems.length > 0
      ? breadcrumbItems[breadcrumbItems.length - 1].name
      : 'Página';

  return (
    <div className="mb-5 w-full">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-xl font-semibold tracking-tight text-black dark:text-white sm:text-2xl">
          {pageTitle}
        </h2>

        <nav aria-label="Breadcrumb" className="overflow-x-auto">
          <ol className="flex min-w-max items-center whitespace-nowrap text-sm text-body dark:text-bodydark">
            <li>
              <Link
                to="/"
                className="flex items-center gap-2 font-medium transition-colors hover:text-primary"
              >
                <SvgIcon
                  name="home"
                  width={14}
                  height={14}
                  className="fill-current"
                />
                <span>Inicio</span>
              </Link>
            </li>

            {breadcrumbItems.map((item, index) => {
              const isLast = index === breadcrumbItems.length - 1;

              return (
                <React.Fragment key={`${item.name}-${index}`}>
                  <li className="mx-2 text-bodydark2">/</li>

                  <li>
                    {item.to && !isLast ? (
                      <Link
                        to={item.to}
                        className="font-medium transition-colors hover:text-primary"
                      >
                        {item.name}
                      </Link>
                    ) : (
                      <span
                        className={
                          isLast
                            ? 'font-semibold text-primary'
                            : 'font-medium text-body dark:text-bodydark'
                        }
                      >
                        {item.name}
                      </span>
                    )}
                  </li>
                </React.Fragment>
              );
            })}
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default BreadcrumbTwo;